import * as yup from 'yup';
import { eJournalEntryPaymentMethod } from '../../types/accounting/eJournalEntryPaymentMethod';
import { eJournalEntryType } from '../../types/accounting/eJournalEntryType';

export const newJournalEntrySchema = yup.object().shape({
  paymentMethod: yup.mixed<eJournalEntryPaymentMethod>().required().nullable().label('Payment Method'),
  orderId: yup.string().required().nullable().label('File Number'),
  amountCents: yup.number().required().nullable().label('Amount'),
  entryType: yup.mixed<eJournalEntryType>().required().nullable().label('Entry Type'),
  note: yup.string().required().nullable().label('Note'),
  initiatedAtDate: yup.date().required().nullable().label('Initiated Date'),
  completedAtDate: yup
    .date()
    .min(yup.ref('initiatedAtDate'), 'Completed Date must be after Initiated Date')
    .nullable()
    .label('Completed Date'),
});
